module.exports = __webpack_public_path__ + "img/logotip.b91bbb77.png";